import { defineComponent as _defineComponent } from 'vue'
import { ImageLoader } from '@tencent/wphk-components-content-loader';
import { MultiJumpContainer } from '@tencent/wphk-components-multi-jump-container';
import { getJumpUrl } from '@/utils';
import { ThemeCardType } from '@/types';
import { computed } from 'vue';

// 暂时不能从外部引入声明：https://cn.vuejs.org/api/sfc-script-setup.html#typescript-only-features
type CardWithEvent = {
  title: string;
  desc: string;
  logo: string;
  url?: string;
  appid?: string;
  username?: string;
  path?: string;
  customEventKey?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'theme-card',
  props: {
  cardInfo: {
    type: Object as () => CardWithEvent,
    required: true,
  },
  cardType: {
    type: String as () => ThemeCardType,
    default: () => ThemeCardType.column,
  },
  isShowCardDesc: {
    type: Boolean,
    default: true,
  },
},
  emits: ['themeCardClick'],
  setup(__props, { emit: emits }) {

const props = __props




// 是否是横版样式卡片
const isRowCard = computed(() => props.cardType === ThemeCardType.row);

function onClick(data) {
  emits('themeCardClick', data);
}

return { __sfc: true,props, emits, isRowCard, onClick, ImageLoader, MultiJumpContainer, getJumpUrl }
}

})